// CSV cell escaping WITH formula/CSV-injection prevention.
// Values starting with = + - @ (or tab/CR) are prefixed with a single quote so
// spreadsheet apps treat them as text, not executable formulas.
export const csvCell = (v) => {
    let s = String(v ?? '');
    if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
    return `"${s.replace(/"/g, '""')}"`;
};
